export default __webpack_public_path__ + "static/media/usd.8dc79f8c.svg";